import { Dispatch } from "react";

import {
  AppSetting,
  ManagerAlarm,
  MemberInfo,
  ProfileImage,
  TermAgreed,
  UserAlarm,
} from "../types/member";

import createDataContext from "./createDataContext";

import {
  BuildingFloorItem,
  BuildingInfoResponse,
} from "../services/buildingServices";

export type UserState = Partial<MemberInfo> & {
  isLoading?: boolean | undefined;

  floor?: BuildingFloorItem;
  building?: BuildingInfoResponse;

  logoUrl?: string;
};

export type UpdateUserState = {
  [key: string]:
    | number
    | string
    | boolean
    | BuildingInfoResponse
    | BuildingFloorItem
    | ProfileImage
    | AppSetting
    | UserAlarm
    | ManagerAlarm
    | TermAgreed[]
    | string[]
    | null;
};

type ActionType =
  | {
      type: "updateField";
      values: UpdateUserState;
    }
  | { type: "resetUser" };

const reducer = (state: UserState, action: ActionType): UserState => {
  switch (action.type) {
    case "updateField":
      return {
        ...state,
        ...action.values,
      };
    case "resetUser":
      return { isLoading: true };
    default:
      return state;
  }
};

const updateField = (dispatch: Dispatch<ActionType>) => {
  return async (params: UpdateUserState) => {
    dispatch({
      type: "updateField",
      values: params,
    });
  };
};

const resetUser = (dispatch: Dispatch<ActionType>) => {
  return async () => {
    dispatch({
      type: "resetUser",
    });
  };
};

export const { useContext: useUserContext, Provider: UserProvider } =
  createDataContext(
    reducer,
    { updateField, resetUser },
    { isLoading: undefined }
  );
